// Law page at `/law`. Ordered list of normative acts + summary of чл. 38.

import { Card, CardContent, CardHeader, CardTitle, H1, P } from '@podium/platform/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/law')({
  component: LawPage,
})

function LawPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-6 px-6 py-8">
      <H1>Нормативна уредба</H1>

      <Card>
        <CardHeader>
          <CardTitle>Приложими нормативни актове</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <P>
            Задължението за публикуване на годишен финансов отчет произтича от следните нормативни
            актове:
          </P>
          <ol className="list-decimal space-y-2 pl-6">
            <li id="csch">
              <a href="https://lex.bg/laws/ldoc/2135721408">Закон за счетоводството</a> —{' '}
              <span id="csch-38">чл. 38</span>, <span id="csch-38-1-3">ал. 1, т. 3</span> и{' '}
              <span id="csch-38-7">ал. 7</span>, <span id="csch-38-8">ал. 8</span>, ал. 9
            </li>
            <li id="zzd">
              <a href="https://lex.bg/laws/ldoc/2121934337">Закон за задълженията и договорите</a>{' '}
              (ЗЗД) — режим на ДЗЗД (неперсонифицирани дружества)
            </li>
            <li id="tz">
              <a href="https://lex.bg/laws/ldoc/-14917630">Търговски закон</a> — чл. 29, ал. 1
              (съдържание на ГФО)
            </li>
            <li id="zjunc">
              <a href="https://lex.bg/laws/ldoc/2135178055">
                Закон за юридическите лица с нестопанска цел
              </a>
            </li>
          </ol>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Извадка от чл. 38 от ЗСч</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <P>
            Съгласно чл. 38 от Закона за счетоводството, годишният финансов отчет на предприятието,
            приет от Общото събрание на съдружниците / акционерите или съответния орган на
            управление, се публикува в срок до 31 март на следващата година.
          </P>
          <P>
            Публикуването се извършва чрез заявяване за вписване и представяне за обявяване в
            Търговския регистър, или за субектите извън обхвата на Търговския регистър — чрез
            публикуване в <b>икономическо издание или в интернет</b>. Публикацията трябва да остане
            достъпна за свободен и неплатен достъп в период от <b>минимум три години</b> от датата
            на публикуване.
          </P>
        </CardContent>
      </Card>

      <P className="text-sm text-muted-foreground">
        Информацията на тази страница е с информативен характер. За правна консултация се обърнете
        към лицензиран счетоводител или юрист.
      </P>
    </div>
  )
}
